module.exports = __webpack_public_path__ + "static/img/barra_3.e405c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_3.png
// module id = OCvd
// module chunks = 0